// src/pages/TermsOfService.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseLayout from '../components/BaseLayout';

export default function TermsOfService() {
  const { t } = useTranslation('legal');

  return (
    <BaseLayout>
      <div className="p-6 max-w-3xl mx-auto bg-black/60 backdrop-blur-md rounded-lg text-white">
        <h1 className="text-3xl font-bold mb-4">{t('terms.title')}</h1>
        <p className="mb-2">
          {t('terms.intro')}
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('terms.useOfService.title')}</h2>
        <p className="mb-4">
          {t('terms.useOfService.content')}
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('terms.accountSecurity.title')}</h2>
        <p className="mb-4">
          {t('terms.accountSecurity.content')}
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('terms.modifications.title')}</h2>
        <p className="mb-4">
          {t('terms.modifications.content')}
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">{t('terms.contact.title')}</h2>
        <p>{t('terms.contact.content')}</p>
      </div>
    </BaseLayout>
  );
}
